export * from './filter-group-header';

import { FilterGroupHeaderComponent } from './filter-group-header';

export const FilterAtoms = [
    FilterGroupHeaderComponent,
]